import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../shared/services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-account-setup-success',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './account-setup-success.component.html',
  styleUrls: ['./account-setup-success.component.scss'],
})
export class AccountSetupSuccessComponent implements OnInit {
  errorMessage: string = '';
  agency = null;

  constructor(
    private readonly authService: AuthService, // Use AuthService for login
  ) {
    console.log('environment',environment);
  }

  ngOnInit(): void {
    if(window.location.href.includes('error') || window.location.href.includes('access_denied')) {
      this.errorMessage = 'Account setup was not completed successfully. Please try again.';
      alert(this.errorMessage);
    }
    else if (!sessionStorage.getItem('hasRefreshed')) {
      sessionStorage.setItem('hasRefreshed', 'true');
      window.location.reload();
    } else {
      sessionStorage.removeItem('hasRefreshed');
    }
  }

  signInWithAzureAD() {
    this.authService.initiateAzureADLogin(); // Initiates Azure AD sign-in
  }
}